import * as _ from 'lodash';

export const exists = (data: any) => data && !_.isEmpty(data);

export const isNotEmptyArray = (data: any) =>
  data && _.isArray(data) && !_.isEmpty(data);

export const utils = { exists, isNotEmptyArray };

export const formatRequestIdentifier = (requestIdentifier: string) => {
  return requestIdentifier ? `R${requestIdentifier.padStart(6, '0')}` : '';
};

export const wordWrap = (text: string, maxNoOfChars: number, br = '\n') =>
  text.replace(
    new RegExp(
      `(?![^\\n]{1,${maxNoOfChars}}$)([^\\n]{1,${maxNoOfChars}})\\s`,
      'g'
    ),
    '$1' + br
  );

export const hexToRgba = (hex: string, opacity: number) => {
  const [r, g, b] = hex.match(/\w\w/g)!.map((x) => parseInt(x, 16));
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};

export const chunkArray = (arr: string[], size: number) => {
  const chunks: string[][] = [];
  for (let i = 0; i < arr.length; i += size) {
    chunks.push(arr.slice(i, i + size));
  }
  return chunks;
};

export default utils;
